import Vue from 'vue'
import AdvCart from './AdvCart'
import Toasted from 'vue-toasted'
import store from '../../vue/store'
import clientLocaleBundle from './locales'
import clientConfigurationBundle from './config'
import AdvProductCard from './AdvProductCard.vue'
import config from '../../vue/config/configPlugin'
import locale from '../../vue/locales/localePlugin'
import AdvCartGiftList from './AdvCartGiftList'
import AdvButtonViewBuy from './AdvButtonViewBuy'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import AdvCartProductList from './AdvCartProductList.vue'
import InitialData from '../../vue/data-components/InitialData.vue'
import AdvMinicartGiftChoiceModal from './AdvMinicartGiftChoiceModal'
import AdvProductGalleryWithVideo from './AdvProductGalleryWithVideo.vue'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import jqueryVueBridgePlugin from '../../vue/plugins/jqueryVueBridgePlugin'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture'
import CookieModal from './cookies/components/CookieModal.vue'
import CookieSettingsButton from './cookies/components/CookieSettingsButton.vue'
import AdvCartProductCustomizationEditor from '../../main/vue/cartProductCustomizations/AdvCartProductCustomizationEditor'
import AdvCartProductCustomizationDisplayValues
from '../../main/vue/cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AfterAddToCartModal from '../../main/vue/AfterAddToCartModal.vue'
import ProductPriceChartModal from '../../main/vue/product/ProductPriceChartModal.vue'
const CheckoutPage = () => import(/* webpackChunkName: "checkout-page" */ './CheckoutPage.vue')
const googleMapPartners = () => import(/* webpackChunkName: "google-map-partners" */ '../../main/vue/googleMaps/components/googleMapPartners')
const AllListingFilters = () => import(/* webpackChunkName: "all-listing-filters" */ '../../main/vue/AllListingFilters.vue')
const AdvListingUsedFilters = () => import(/* webpackChunkName: "adv-listing-used-filters" */ '../../main/vue/AdvListingUsedFilters.vue')
const AdvButtonViewBuyCombo = () => import(/* webpackChunkName: "adv-button-view-buy-combo" */ '../../main/vue/AdvButtonViewBuyCombo.vue')
const AdvProductGallery = () => import(/* webpackChunkName: "adv-product-gallery" */ './AdvProductGallery.vue')
const GiftCardPage = () => import(/* webpackChunkName: "gift-card-page" */ '../../main/vue/giftCards/GiftCardPage.vue')

import KlarnaModal from './KlarnaModal.vue'
import KlarnaEntry from "./KlarnaEntry.vue";

// import ViberForm from '../../main/vue/ViberForm.vue'
// import ViberSignOut from '../../main/vue/ViberSignOut.vue'
// import BirthdayForm from '../../main/vue/BirthdayForm'

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)
Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })
Vue.use(jqueryVueBridgePlugin)

window.Vue = new Vue({
  el: '#app',
  store,
  config,
  locale,
  jqueryVueBridgePlugin,
  components: {
    InitialData,
    LiveProductData,
    CookieModal,
    CookieSettingsButton,
    AdvProductCard,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvCart,
    AdvProductGalleryWithVideo,
    AdvMinicartGiftChoiceModal,
    AdvHtmlPicture,
    AdvCartProductCustomizationEditor,
    AdvCartProductCustomizationDisplayValues,
    AfterAddToCartModal,
    ProductPriceChartModal,
    AdvProductGallery,
    AdvButtonViewBuyCombo,
    AdvListingUsedFilters,
    AllListingFilters,
    CheckoutPage,
    googleMapPartners,
    GiftCardPage,
    KlarnaModal,
    KlarnaEntry
    // ViberForm,
    // ViberSignOut
    // BirthdayForm
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal () {
      return store.getters.cartProductWeightTotal
    },
    cartDefaultCouponCode () {
      return store.getters.getDefaultCouponCode
    },
    cartDefaultCouponDiscount () {
      return parseFloat(store.getters.getDefaultCouponDiscount).toFixed(2)
    },
    cartDefaultCouponName () {
      return store.getters.getDefaultCouponName
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
})
